import { QRCodeSVG } from 'qrcode.react';
import { resolvePortalAccessUrl } from '../lib/portalAccessUrl';
import { PHONE_QR_MODAL_BODY, PHONE_QR_MODAL_TITLE } from '../lib/desktopAppIcon';
import './PhoneAccessQr.css';

interface PhoneAccessQrProps {
  titleId?: string;
  compact?: boolean;
}

export default function PhoneAccessQr({ titleId, compact = false }: PhoneAccessQrProps) {
  const portalUrl = resolvePortalAccessUrl();

  return (
    <div className={`phone-access-qr ${compact ? 'phone-access-qr-compact' : ''}`}>
      <h3 id={titleId} className="phone-access-qr-title">
        {PHONE_QR_MODAL_TITLE}
      </h3>
      <p className="phone-access-qr-body scannable-bullet-text">{PHONE_QR_MODAL_BODY}</p>
      <div className="phone-access-qr-code-wrap">
        <QRCodeSVG
          value={portalUrl}
          size={compact ? 160 : 200}
          level="M"
          bgColor="#ffffff"
          fgColor="#000000"
          includeMargin
        />
      </div>
      <p className="phone-access-qr-url">{portalUrl}</p>
    </div>
  );
}
